'use strict';

export const Roles = {
  public: 0,
  admin: 1,
  manager: 2, // Regional Manager
  courier: 3,
  supplier: 7,
  customer: 8
}

function urlBase64Decode(str) {
  var output = str.replace(/-/g, '+').replace(/_/g, '/');
  switch (output.length % 4) {
    case 0:
      {
        break;
      }
    case 2:
      {
        output += '==';
        break;
      }
    case 3:
      {
        output += '=';
        break;
      }
    default:
      {
        throw 'Illegal base64url string!';
      }
  }

  return decodeURIComponent(escape(typeof window === 'undefined' ? atob(output) : window.atob(output))); //polyfill https://github.com/davidchambers/Base64.js
}

function decodeToken(token) {
  var parts = token.split('.');
  if (parts.length !== 3) {
    throw new Error('JWT must have 3 parts');
  }

  var decoded = urlBase64Decode(parts[1]);
  if (!decoded) {
    throw new Error('Cannot decode the token');
  }

  return JSON.parse(decoded);
}

function getTokenExpirationDate(token) {
  var decoded;
  decoded = decodeToken(token);

  if (typeof decoded.exp === "undefined") {
    return null;
  }

  var date = new Date(0); // The 0 here is the key, which sets the date to the epoch
  date.setUTCSeconds(decoded.exp);

  return date;
}

export function isTokenExpired() {
  if (window.localStorage.id_token) {
    var date = getTokenExpirationDate(window.localStorage.id_token);
    var offsetSeconds = 0;
    if (date === null) {
      return false;
    }
    // Token expired?
    return !(date.valueOf() > (new Date().valueOf() + (offsetSeconds * 1000)));
  } else {
    return true;
  }
}
export function getToken() {
  return window.localStorage.id_token;
}
export function login(token) {
  window.localStorage.id_token = token;
}

export function getUser() {

  if (window.localStorage.id_token) {
    return decodeToken(window.localStorage.id_token);
  } else {
    return {
      role: Roles.public
    };
  }
}

export function logout() {
  //delete window.localStorage.id_token;
  window.localStorage.clear();
}
export function isAuth() {
  return typeof window.localStorage.id_token === "undefined" ? false : true;
}

export function isEligible(role = []) {
  if (role.indexOf(Roles.public) > -1) {
    return true;
  } else {
    return (role.indexOf(getUser().role) > -1 ? true : false);
  }
}

export function isAllowed(role) {
  if (getUser().role === role || role === Roles.public) {
    return true;
  } else {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/modules/session.js